import { useEffect, useRef, useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { Envelope } from "./components/invite/Envelope";
import { HeroSection } from "./components/invite/HeroSection";
import { CountdownSection } from "./components/invite/CountdownSection";
import { ScheduleSection } from "./components/invite/ScheduleSection";
import { LocationSection } from "./components/invite/LocationSection";
import { BlessingsSection } from "./components/invite/BlessingsSection";
import { FooterSection } from "./components/invite/FooterSection";
import { DownloadBar } from "./components/invite/DownloadBar";

function App() {
  const [opened, setOpened] = useState(false);
  const [muted, setMuted] = useState(false);
  const audioRef = useRef(null);

  const startMusic = () => {
    const el = audioRef.current;
    if (!el) return;
    try {
      el.volume = 0;
      el.currentTime = 0;
      const p = el.play();
      if (p && p.catch) p.catch(() => {});
      // Gentle fade-in over ~1.4s
      const target = 0.55;
      const steps = 28;
      let i = 0;
      const iv = setInterval(() => {
        i += 1;
        el.volume = Math.min(target, (target * i) / steps);
        if (i >= steps) clearInterval(iv);
      }, 50);
    } catch (e) {
      // ignore
    }
  };

  const toggleMute = () => {
    const el = audioRef.current;
    if (!el) return;
    const next = !muted;
    setMuted(next);
    el.muted = next;
  };

  useEffect(() => {
    // Ensure audio element exists before Envelope may want to play it
    if (audioRef.current) audioRef.current.loop = true;
  }, []);

  return (
    <div
      className="theme-app snap-container"
      data-testid="invite-app"
      style={{ backgroundImage: "url(/assets/texture.png)" }}
    >
      <audio
        ref={audioRef}
        src="/assets/bg-music.mp3"
        loop
        preload="auto"
        data-testid="bg-music"
      />

      {!opened && (
        <Envelope
          onOpen={startMusic}
          onDone={() => setOpened(true)}
        />
      )}

      <HeroSection />
      <CountdownSection />
      <ScheduleSection />
      <LocationSection />
      <BlessingsSection />
      <FooterSection />
      <DownloadBar />

      {opened && (
        <button
          className={`music-toggle ${muted ? "muted" : ""}`}
          onClick={toggleMute}
          aria-label={muted ? "Unmute music" : "Mute music"}
          data-testid="music-toggle-btn"
        >
          {muted ? (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
              <line x1="23" y1="9" x2="17" y2="15" />
              <line x1="17" y1="9" x2="23" y2="15" />
            </svg>
          ) : (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
              <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
              <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
            </svg>
          )}
        </button>
      )}

      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
